import { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";

const EMPTY = { nombre: "", apellido: "", email: "", DNI: "", telefono: "", domicilio: "", fecNac: "" };

// Solo junta datos en memoria: la persona recien se crea de verdad al enviar el
// formulario principal, dentro de la misma transaccion que todo lo demas — asi no
// queda una persona huerfana si el staff abandona el formulario despues de usar esto.
export const CrearPersonaModal = ({ show, onClose, onSave, showFecNac = false }) => {
  const [data, setData] = useState(EMPTY);

  const set = (field) => (e) => setData({ ...data, [field]: e.target.value });

  const handleSave = () => {
    if (!data.nombre.trim() || !data.apellido.trim()) return;
    onSave({ perfil_id: null, ...data });
    setData(EMPTY);
  };

  const handleClose = () => {
    setData(EMPTY);
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Crear nueva persona</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Nombre</Form.Label>
            <Form.Control value={data.nombre} onChange={set("nombre")} autoFocus />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Apellido</Form.Label>
            <Form.Control value={data.apellido} onChange={set("apellido")} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>DNI</Form.Label>
            <Form.Control value={data.DNI} onChange={set("DNI")} inputMode="numeric" />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value={data.email} onChange={set("email")} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Teléfono</Form.Label>
            <Form.Control value={data.telefono} onChange={set("telefono")} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Domicilio</Form.Label>
            <Form.Control value={data.domicilio} onChange={set("domicilio")} />
          </Form.Group>
          {showFecNac && (
            <Form.Group className="mb-2">
              <Form.Label>Fecha de nacimiento</Form.Label>
              <Form.Control type="date" value={data.fecNac} onChange={set("fecNac")} />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={!data.nombre.trim() || !data.apellido.trim()}
        >
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CrearPersonaModal;
